export class Utils {
    public static isNullOrEmpty(value: string): boolean {
        return (value == null || value.trim() === '');
    }
}
